import { AfterContentInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { StradaDTO } from '../../models/strada-dto';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { MessageService } from '../../services/message.service';
import { TerritorioService } from '../../services/territorio/territorio-service';

@Component({
	selector: 'lib-strada',
	templateUrl: './strada.component.html',
	styleUrls: ['./strada.component.css']
})
export class StradaComponent implements OnInit, OnDestroy, AfterContentInit {

	form: FormGroup;

	@Input()
	viewOnly: boolean;
	@Input()
	strada: StradaDTO;
	dugs$: Observable<Array<string>>;

	@Output()
	done: EventEmitter<ComponentOutputStatus<StradaDTO>> = new EventEmitter<ComponentOutputStatus<StradaDTO>>();

	changes$: BehaviorSubject<ComponentOutputStatus<StradaDTO>>

	subscription: Subscription;
	subScriptionChange: Subscription;

	constructor(
		private msg: MessageService,
		private territorio: TerritorioService) { }

	ngOnInit() {
		this.form = new FormGroup({})
		if (!this.strada) {
			this.initStrada();
		}
		const stradaIndirizzo = new FormControl({ value: this.strada.inidirizzo, disabled: this.viewOnly }, c => {
			if (this.viewOnly) return {};
			return String(c.value).trim().length > 0
				? {}
				: { required: true };
		});
		this.form.addControl('stradaIndirizzo', stradaIndirizzo);
		const stradaCivico = new FormControl({ value: this.strada.civico, disabled: this.viewOnly }, c => {
			if (this.viewOnly) return {};
			return String(c.value).trim().length > 0
				? {}
				: { required: true };
		});
		this.form.addControl('stradaCivico', stradaCivico);

		const stradaOut = new StradaDTO;
		stradaOut.inidirizzo = stradaIndirizzo.value;
		stradaOut.civico = stradaCivico.value;
		this.changes$ = new BehaviorSubject<ComponentOutputStatus<StradaDTO>>(ComponentOutputStatus.of(false, stradaOut));

		this.subScriptionChange = this.form.valueChanges.pipe(
			tap(valueChange => {
				const stradaOut = new StradaDTO();
				stradaOut.inidirizzo = valueChange.stradaIndirizzo;
				stradaOut.civico = valueChange.stradaCivico;
				return this.changes$.next(ComponentOutputStatus.of(
					/* 	this.form.valid  && */
					stradaOut.inidirizzo != null
					//    &&  stradaOut.tipoToponimo != null
					&& stradaOut.civico != null, stradaOut)
				);
			})
		).subscribe();

		this.subscription = this.changes$.subscribe(x => {
			this.done.emit(x)
			console.log("changes$", x);
		});
		
		this.changes$.next(ComponentOutputStatus.of(
			/* 	this.form.valid  && */
			stradaOut.inidirizzo != null
			//    &&  stradaOut.tipoToponimo != null
			&& stradaOut.civico != null, stradaOut)
		);
	}
	initStrada() {
		this.strada = new StradaDTO();
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
		this.subScriptionChange.unsubscribe();
	}

	ngAfterContentInit(): void {
		if (this.strada.inidirizzo != null && this.strada.tipoToponimo != null && this.strada.civico != null) {
			this.form.updateValueAndValidity({ emitEvent: true });
		}
	}
}